// Function to fetch config.json and get the base URL
const getBaseUrl = () => {
  const fetchDetails = async () => {
    try {
      // Fetch the config.json file
      const response = await fetch('/config.json');

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      // Parse the JSON response
      const config = await response.json();

      // Extract configuration values
      const backendIP = await config.backendUrl;

      // Return the base URL based on the config
      return `http://${backendIP}/`;
    } catch (error) {
      console.error('Error fetching config:', error);
      return 'https://localhost:82/';
    }
  };

  return process.env.REACT_APP_BACKEND_URL;

  //return 'https://4gjv6fwk-5001.inc1.devtunnels.ms/';

  //return 'https://rqjvqjq1-5001.inc1.devtunnels.ms/';
  // return fetchDetails();

  // return "https://192.168.1.27/swagger/index.html";
  // return "http://192.168.1.24:7200/";
  // return "http://192.168.1.60:4000/";

  // https://sb02kkq1-44388.inc1.devtunnels.ms/
  // return "https://j1x5zj0t-44388.inc1.devtunnels.ms/";
};
export default getBaseUrl;
